import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { GraphEventOptionsPlugin } from './app/core/utils/graph-event-options.plugin';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import {
	HTTP_INTERCEPTORS,
	HttpClient,
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeCa from '@angular/common/locales/ca';
import LocaleEs from '@angular/common/locales/es';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// FIREBASE
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routing';
import { ErrorInterceptor } from './app/core/helpers/error.interceptor';
import { JwtInterceptor } from './app/core/helpers/jwt.interceptor';
import { environment } from './environments/environment';

registerLocaleData(LocaleEs, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeCa, 'ca');

if (environment.production) {
	enableProdMode();
}

export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http);
}

bootstrapApplication(AppComponent, {
	providers: [
		{ provide: EVENT_MANAGER_PLUGINS, useClass: GraphEventOptionsPlugin, multi: true },
		provideRouter(routes),
		provideAnimations(),
		importProvidersFrom(
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: httpTranslateLoader,
					deps: [HttpClient]
				}
			})
		),
		HttpClient,
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: LOCALE_ID, useValue: 'es' },
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		provideFirestore(() => getFirestore()),
		provideHttpClient(withInterceptorsFromDi())
	]
}).catch((err) => console.error(err));
